<template>
    <div class="np-form-final-field">
        <span class="np-form-final-field__label">
            {{ label }}
        </span>
        <span class="np-form-final-field__dashed-line"></span>
        <span class="np-form-final-field__value">
            {{ value }}
        </span>
    </div>
</template>

<script>
export default {
    name: "NewPaymentFormFinalField",
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mixins-and-vars';

$parent: '.np-form-final-field';

#{$parent} {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 14px;

    @include mobile {
        flex-direction: column;
    }

    &__label {
        display: block;
        white-space: nowrap;

        @include mobile {
            font-weight: 500;
            border-bottom: 1px dashed #33333399
        }
    }

    &__value {
        display: block;
        white-space: nowrap;
    }

    &__dashed-line {
        max-width: 100%;
        width: 100%;
        margin-bottom: 9px;
        margin-left: 12px;
        margin-right: 12px;
        border-bottom: 1px dashed rgba(125, 121, 135, 0.4);

        @include mobile {
            display: none;
        }
    }
}

</style>